import { gql } from '@apollo/client'

const ORGANIZATION_MODEL = `
  id
  name
  type
  size
  status
  location {
    city
    country
  }
  experts {
    id
    first_name
    last_name
  }
  description
  url
`

export const ORGANIZATIONS_AUTOCOMPLETE = gql`
  query OrganizationsAutocomplete($query: String!) {
    organizationsAutocomplete(query: $query) {
      id
      name
    }
  }
`

export const MERGE_ORGANIZATION = gql`
  mutation MergeOrganization($removeOrgId: ID!, $remainOrgId: ID!) {
    mergeOrganization(removeOrgId: $removeOrgId, remainOrgId: $remainOrgId) {
        ${ORGANIZATION_MODEL}
    }
  }
`

export const LOAD_SINGLE_ORGANIZATION_QUERY = gql`
  query Organization($organizationId: ID!) {
    organization(id: $organizationId) {
      ${ORGANIZATION_MODEL}
    }
  }
`

export const ORG_TYPES = gql`
  query OrgTypes {
    orgTypes
  }
`

export const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation UpdateOrganization($organizationId: ID!, $organization: OrganizationInput!) {
    updateOrganization(
      organizationId: $organizationId
      organization: $organization
    ) {
      ${ORGANIZATION_MODEL}
    }
  }
`
